import React from 'react'
import Header from '../../../Components/Header'

function StartingStrength({ heading_size = 2 }) {
    return (
        <>
            <Header text={"Starting Strength"} level={heading_size}/>
            <div>
                Data
            </div>
        </>
    )
}

export default StartingStrength